var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.country === 16 || _vm.country === '16')?_c('a',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"id":"shaim_ares_button"},on:{"click":_vm.loadShaimAresData}},[_vm._v(_vm._s(_vm.translations['Load data from ARES']))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }